<template>
  <b-modal :id="id"
           :size="size"
           centered
           :hide-header="true"
           :hide-header-close="true"
           :hide-footer="true"
           @hidden="() => this.$emit('hidden')"
  >
    <slot></slot>
  </b-modal>
</template>

<script>
export default {
  name: "EsgBaseDashboardModal",
  props: {
    id: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'md'
    }
  }
}
</script>

<style scoped>
>>> .modal-content {
  border-radius: 20px;
}

>>> .modal-body .esg-base-list-container {
  padding: 0;
}
</style>